import React from 'react';
import DatePicker from 'react-datepicker';
import {
  Button,
  Form,
  Icon,
  Label,
  Message,
  Segment,
} from 'semantic-ui-react';

export const CustomInputComponent = (props) => {
  if (props.select) {
    return (
      <Form.Field>
        <Form.Select
          value={props.value}
          label={props.label}
          search={true}
          onChange={(e, d) => props.onChange({
            target: {
              name: d.name,
              value: d.value,
            }
          })}
          options={props.options}
          placeholder="Select one..."
          name={props.name}
        />
        {/*
          touched[props.name] &&
          errors[props.name]
            ? (
                <Label
                  basic
                  // color="red"
                  style={{ marginTop: '0.25em' }}
                  pointing
                >{errors[props.name]}
                </Label>
              )
            : null
        */}
      </Form.Field>
    );
  }
  if (props.datepicker) {
    return (
      <Form.Field className={props.required ? 'required' : ''}>
        <label>{props.label}</label>
        <DatePicker
          dropdownMode="select"
          maxDate={props.maxDate ? props.maxDate : null}
          minDate={props.minDate ? props.minDate : null}
          onChange={(dateObj, t) => props.onChange({
            target: { name: props.name, value: dateObj }
          })}
          onChangeRaw={e => e.preventDefault()}
          name={props.name}
          placeholderText="Select a date..."
          selected={props.value}
          showYearDropdown
        />
      </Form.Field>
    );
  }
  return (
    <Form.Field required>
      <Form.Input
        name={props.name}
        type="text"
        onBlur={props.onBlur}
        onChange={props.onChange}
        label={`${props.label}${!props.required ? ' (optional)' : ''}`}
        value={props.value}
        error={props.touched && props.error && props.required}
        required={props.required}
      />
      {
        props.touched && props.error && props.required &&
          <Label
            basic
            // color="red"
            style={{ marginTop: '0.25em' }}
            pointing
          >{props.errorMessage}
          </Label>
      }
    </Form.Field>
  );
};
